module.exports = __webpack_public_path__ + "static/media/bq_hammerhead_shark.b8a19034.png";